import request from '../common/request.js';

//获取钉钉列表
export function GetDingtalkList(payload) {
    return request.post('/Dingtalk/GetDingtalkList', payload);
}
//更新钉钉列表
export function UpdateDingtalkInfo(payload) {
    return request.post('/Dingtalk/UpdateDingtalkInfo', payload);
}

//删除钉钉列表
export function DeleteDingtalkInfo(payload) {
    return request.post('/Dingtalk/DeleteDingtalkInfo', payload);
}

//添加钉钉
export function AddDingtalkInfo(payload) {
    return request.post('/Dingtalk/AddDingtalkInfo', payload);
}